<template>
    <div class="flex-col">
        <vnavbar title="转运详情" class="backbar" left-text="返回" left-arrow @click-left="back" />
        <div class="header">
            <div class="patient">
                <div class="name">{{surgeryInfo.patient_name}}</div>
                <div class="bed">{{surgeryInfo.sex||'--'}}/{{surgeryInfo.age||'--'}}/{{surgeryInfo.bed_no||'--'}}</div>
            </div>
            <div>
            <div class="more"><div class="moredevice">{{surgeryInfo.surgeries}}</div><div @click="isShowMore=!isShowMore">查看更多<span><i :class="isShowMore?'el-icon-arrow-up':'el-icon-arrow-down'"></i></span></div></div>
            <div v-if="isShowMore" class="surgery">
                <div>台次:{{surgeryInfo.scheduled_sequence}}</div>
                <div>住院号:{{surgeryInfo.visit_no}}</div>
                <div>手术间:{{surgeryInfo.dic_operating_room}}</div>
                <div>科室:{{surgeryInfo.dic_section}}</div>
                <div>术前诊断:{{surgeryInfo.plan_diseases}}</div>
                <div>手术医生:{{surgeryInfo.surgeon}}</div>
                <div>手术部位:{{surgeryInfo.surgical_site}}</div>
                <div>麻醉方式:{{surgeryInfo.anaes_methods}}</div>
                <div class="time">转运开始时间:{{transferFlows && transferFlows[0] && this.$moment(transferFlows[0].occur_time).format(`YYYY-MM-DD HH:mm:ss`)}}</div>
                <div class="time">手术计划开始时间:{{surgeryInfo.plan_time && this.$moment(surgeryInfo.plan_time).format(`YYYY-MM-DD HH:mm:ss`)}}</div>
            </div>
            </div>
        </div>
        <div v-if="transferFlows && transferFlows.length>0" class="scrollContent" :style="{'height':`${this.isShowMore? (this.screenHeight - 324):(this.screenHeight - 173)}px`}">
        <vpullrefresh v-model="refreshing" @refresh="onRefresh">
            <div class="content" v-for="(flow, index) in transferFlows" :key="index">
                <div class="line"></div>
                <div class="panel">
                    <div v-if="index == 0" class="monthday">{{flow.occur_time && $moment(flow.occur_time).format(`MM-DD`)}}</div>
                    <div class="date" :style="{'top':`${index == 0 ? 22:10}px`}">{{flow.occur_time && $moment(flow.occur_time).format(`HH:mm`)}}</div>
                    <div class="step">
                        <div class="steprowone">{{flow.modifier}} {{flow.event_name}} <span v-if="flow.status==2||flow.status==0" style="font-size:14px;"><vtag plain type="primary">{{flow.status==2?'已撤回':'撤回操作'}}</vtag></span></div><div>{{flow.modifier}} <a :href="'tel:'+flow.worker_tel"><vicon name="phone" color="#009687" class="phone" /></a></div>
                        <div class="steprowtwo">转运阶段:{{flow.flow_surgery_stage}}</div>
                        <div class="steprowtwo">转运状态:{{flow.transfer_circulation && flow.transfer_circulation.data_state_name}}</div>
                        <div class="remark">备注:{{flow.remark}}</div>
                    </div>
                </div>
            </div>
        </vpullrefresh>
        </div>
        <div v-else>
            <empty description="暂无数据" class="empty" />
        </div>
        <div class="bottom">
            <vbutton class="btnTrans" v-if="buttons && buttons.length>0" v-for="(btn, index) in buttons" :key="index" type="info"
                @click="handlerTransfer(btn)">{{
                btn.button_name
                }}</vbutton>
        </div>
        <van-dialog v-model="clickObj.dialogIsShow" title="备注" show-cancel-button @cancel="clickObj.dialogIsShow = false"
            @confirm="confirmAddTransfer(clickObj.button)">
            <vfield class="dialogRemark" v-model="clickObj.dialogRemark" type="textarea" placeholder="请输入注意事项,最多150字"
                rows="3" autosize />
        </van-dialog>
        <van-dialog v-model="document.dialogFormVisible" width="100%" show-cancel-button @cancel="document.dialogFormVisible = false"  @confirm="$refs.doc.confirm()" class="dialog-adverse">
            <!-- <DocFrame ref="doc" :style="{'height':`${ this.screenHeight - 60}px`}" :docno="document.docno" :guid="document.docguid" :surgeryId="document.surgeryId" docname="患者转运记录单" @saved="afterDocumentSaved(document.button)"></DocFrame> -->
        <DocInfo ref="doc" :docId="document.docno" :surgeryId="document.surgeryId" :doc="document.doc" :isPagination="isPagination" @afterSaved="afterDocumentSaved(document.button)"></DocInfo>
        </van-dialog>
    </div>
</template>

<script>
import { NavBar as vnavbar, Empty, Button as vbutton, PullRefresh as vpullrefresh, Dialog, Field as vfield, Icon as vicon, Tag as vtag } from 'vant'
import 'vant/lib/index.css'
import { mapGetters } from 'vuex'
import DocInfo from '../DocInfo.vue'
export default {
    name: `TransferInfo`,
    components: { DocInfo, vnavbar, Empty, vbutton, vpullrefresh, [Dialog.Component.name]: Dialog.Component, vfield, vicon, vtag },
    data() {
        return {
            surgeryId: this.$route.query.surgeryId,
            transferId: this.$route.query.transferId,
            surgeryInfo: this.$route.params.surgeryInfo,
            buttons: this.$route.params.buttons,
            transferFlows: null,
            isShowMore: false,
            clickObj: {
                dialogIsShow: false,
                dialogRemark: ``,
                button: null
            },
            users: [],
            document: {
                // 当前打开的文书一些内容
                dialogFormVisible: false,
                docguid: ``,
                surgeryId: ``,
                docno: 0,
                button: null,
                doc: null
            },
            refreshing: false,
            documentConfig: [],
            isPagination: this.$root.MobileDocIsPagination == `1`
        }
    },
    computed: {
        ...mapGetters([`currentUser`, `sysuser/workers`, `screenHeight`, `hospital_ward_auth`, `operation_ward_auth`, `active_hospital_ward`])
    },
    created() {
        let that = this
        this.$store.dispatch(`ADD_CURRENTUSER`).then(() => {
            this.$store.dispatch(`sysuser/ADD_WORKERS`)
            // 获取转运详情
            that.loadTransferDetail()
            this.loadAllUsers()
            this.loadDocumentConfig()
        })
    },
    mounted() {},
    methods: {
        loadDocumentConfig() {
            let that = this
            return new Promise((resolve, reject) => {
                let req = this.myaxios.get(`/api/AcisSystem/DocumentConfig/Get`)
                req.then(DocumentConfig => {
                    that.documentConfig = DocumentConfig
                    resolve(DocumentConfig)
                })
            })
        },
        onRefresh() {
            let that = this
            that.loadTransferDetail().then((data) => {
                if (that.transferFlows && that.transferFlows.length > 0) {
                    that.reloadButtons(that.transferFlows)
                }
            })
            that.refreshing = false
        },
        loadDocument(row) {
            let nextNode = row.next_dic_transfer_circulation
            this.document.docno = nextNode.doc_code
            let doc = this.documentConfig.find(i => i.document_id == this.document.docno)
            if (!this.document.docno || !doc) {
                this.$message.warning(`未查到相关文书，请检查:编号为:${nextNode.doc_code},在文书系统对应的文书！`)
                return
            }
            this.document.docguid = `患者转运记录单_${row.surgeryId}_${this.document.docno}`
            this.document.surgeryId = row.surgeryId
            this.document.dialogFormVisible = true
            this.document.button = row
            this.document.doc = doc
            this.$nextTick(() => {
                this.$refs.doc.loadDocInfo()
            })
        },
        afterDocumentSaved(button) {
            this.confirmAddTransfer(button)
            this.document.dialogFormVisible = false
        },
        loadAllUsers() {
            let that = this
            return new Promise((resolve, reject) => {
                let req = this.myaxios.get(`/api/AcisSystem/SysUser/Get`)
                req.then(async data => {
                    that.users = data
                    resolve()
                }).catch(e => reject(e))
            })
        },
        isHaveWithDrawRole(transfers) {
            let transferInfo = null
            for (let index = transfers.length - 1; index >= 0; index--) {
                if (transfers[index].status == 1) {
                    transferInfo = transfers[index]
                    break
                }
            }
            let currentTransferCirculation = transferInfo && transferInfo.transfer_circulation || null
            // 当前记录由我添加且允许撤回且当前状态不是撤回
            if (transferInfo && this.currentUser && transferInfo.dic_worker_id == this.currentUser.dic_worker_id && transferInfo.dic_transfer_circulation_id > 0 && currentTransferCirculation && currentTransferCirculation.is_alow_withdraw) {
                return {
                    transferId: transferInfo.id,
                    surgeryId: transferInfo.biz_surgery_info_id,
                    next_dic_transfer_circulation_id: 0,
                    is_withdraw: true,
                    button_name: `撤回`
                }
            }
        },
        isHaveHandRole(transferCirculation) {
            if (this.currentUser.workerInfo && this.currentUser.workerInfo.Enum_WorkerRole && transferCirculation) {
                return transferCirculation.worker_role_arr && transferCirculation.worker_role_arr.indexOf(this.currentUser.workerInfo.Enum_WorkerRole) > -1
            } else {
                return false
            }
        },
        reloadButtons(transfers) {
            let that = this
            let button = []
            let cehuibtn = this.isHaveWithDrawRole(transfers)
            if (cehuibtn) {
                button.push(cehuibtn)
            }
            let transferInfo = that.transferFlows[that.transferFlows.length - 1]
            let nextTransferCirculation = transferInfo.next_transfer_circulation
            if (this.isHaveHandRole(nextTransferCirculation)) {
                let nodebtn = {
                    transferId: transferInfo.id,
                    surgeryId: transferInfo.biz_surgery_info_id,
                    next_dic_transfer_circulation_id: nextTransferCirculation && nextTransferCirculation.id || 0,
                    next_dic_transfer_circulation: nextTransferCirculation,
                    is_withdraw: false,
                    button_name: nextTransferCirculation && nextTransferCirculation.button_name || ``
                }
                button.push(nodebtn)
            }
            this.buttons = button
        },
        loadTransferDetail() {
            return new Promise((resolve, reject) => {
                let req = this.myaxios.mobile_get(`/api/TransferEvent/TransferOccurEvent/GetTransferFlow?transferId=${this.transferId}&surgeryId=${this.surgeryId}`)
                req.then(async data => {
                    this.transferFlows = data
                    resolve()
                }).catch(e => reject(e))
            })
        },
        back() {
            let fromData = this.$route.query.from // 给第三方的url 是免登录的
            if (!fromData) {
                this.$router.back()
                return
            }

            try {
                const { path, query } = JSON.parse(fromData)
                this.$router.push({ path, query })
            } catch (e) {
                console.error(`返回失败`, e)
                this.$router.back()
            }
        },
        handlerTransfer(button) {
            this.clickObj.dialogIsShow = false
            this.clickObj.dialogRemark = ``
            if (button.next_dic_transfer_circulation && button.next_dic_transfer_circulation.doc_code) {
                this.loadDocument(button)
            } else if (button && button.button_name == `接患者` || button.button_name == `撤回`) {
                this.clickObj.dialogIsShow = true
                this.clickObj.button = button
            } else {
                this.confirmAddTransfer(button)
            }
        },
        confirmAddTransfer(button) {
            let that = this
            return new Promise((resolve, reject) => {
                let data = {
                    id: button.transferId, // 当前转运记录对应id
                    biz_surgery_info_id: button.surgeryId,
                    is_withdraw: button.is_withdraw, // 是否是撤回操作
                    remark: that.clickObj && that.clickObj.dialogRemark,
                    next_dic_transfer_circulation_id: button.next_dic_transfer_circulation_id // 下一转运节点ID，即点击的按钮对应的id
                }
                let req = that.myaxios.mobile_post(`/api/TransferEvent/TransferOccurEvent/PostTransfer`, data)
                req.then(async data => {
                    if (!button.is_withdraw) {
                        let nextNode = button.next_dic_transfer_circulation
                        if (nextNode.message_template) {
                            // 定义了消息模板，则发消息
                            that.sendMessage(data, button)
                        }
                    } else {
                        that.withDrawMessage(button.transferId)
                    }
                    that.clickObj.dialogIsShow = false
                    that.transferId = data.id
                    that.loadTransferDetail().then((data) => {
                        if (that.transferFlows && that.transferFlows.length > 0) {
                            that.reloadButtons(that.transferFlows)
                        }
                    })
                    resolve()
                }).catch(e => {
                    that.clickObj.dialogIsShow = false
                    that.loadTransferDetail()
                })
            })
        },
        sendMessage(data, button) {
            let nextNode = data.next_transfer_circulation
            // 消息发送
            let messageheader = this.createMessageHeader(data, button)
            messageheader.ac_sys_user_roles = nextNode.worker_role_arr.join(`,`)
            this.saveMessage(messageheader)
        },
        createMessageHeader(data, button) {
            let surgeryInfo = data.surgery_info
            let currentNode = button.next_dic_transfer_circulation
            let title = `${data.modifier}给你发了消息`
            let content = `${currentNode.message_template}${data.remark != `` ? `,特别关注:` + data.remark : ``} `
            content = content.replace(`{患者姓名}`, surgeryInfo.patient_name)
            content = content.replace(`{手术医生}`, surgeryInfo.surgeon)
            content = content.replace(`{登陆用户}`, this.currentUser.dic_worker_name)
            let message = {
                content: content,
                isExtraBtnClick: false,
                send_type: 2,
                title: title,
                is_alow_receive: true,
                biz_id: data.id,
                biz_type: `6`,
                enum_message_status: 1
            }
            return message
        },
        getReceiverIds(receiverRoles) {
            let that = this
            let roleWorkerIds = _.filter(this[`sysuser/workers`], worker => {
                return receiverRoles.indexOf(worker.enum_worker_role) > -1
            }).map(i => i.id)
            let roleUserIds = that.getAcUserId(roleWorkerIds)
            return roleUserIds || []
        },
        getAcUserId(roleWorkerIds) {
            let userids = _.filter(this.users, user => {
                return user.is_deleted == false && roleWorkerIds.indexOf(user.dic_worker_id) > -1
            }).map(i => i.id)
            return userids || []
        },
        saveMessage(row) {
            return new Promise((resolve, reject) => {
                let req = this.myaxios.post(`/api/Operation/MessageHeader/Save`, row)
                req.then(data => {
                    resolve(data)
                }).catch(e => reject(e))
            })
        },
        withDrawMessage(tranferId) {
            this.myaxios.delete(`/api/Operation/MessageHeader/DeleteByBizId?bizId=${tranferId}`)
        }
    },
    watch: {
        $route: function(newUrl, oldUrl) {
            if (newUrl.path == `/t_transferInfo`) {
                this.surgeryId = this.$route.query.surgeryId
                this.transferId = this.$route.query.transferId
                this.surgeryInfo = this.$route.params.surgeryInfo
                this.buttons = this.$route.params.buttons
                // 获取转运详情
                this.loadTransferDetail()
            }
        }
    }
}
</script>
<style lang="less" scoped>
@import '../mobile_common.css';
.backbar{
    background-color: #04A891;
    border:unset !important;
    /deep/ .van-icon{
        color:#ffffff !important;
    }
    /deep/ .van-nav-bar__text{
        color:#ffffff !important;
    }
    /deep/ .van-nav-bar__title{
        color:#ffffff !important;
    }
}
.van-hairline--bottom::after{
    border-bottom-width:0px !important;
}
.header {
    color:#ffffff !important;
    background: #04A891 !important;
    font-size: 14px;
    text-align: left;
    .patient {
        line-height: 23px;
        position: relative;
        display: -webkit-box;
        display: -webkit-flex;
        display: flex;
        -webkit-box-align: center;
        -webkit-align-items: center;
        align-items: center;
        height: 46px;
        .name{
            padding:0 20px;
            font-size: 17px;
        }
    }
    .surgery {
        border-top: 1px dashed #ffffff;
        display: -webkit-box;
        display: -webkit-flex;
        display: flex;
        -webkit-box-align: center;
        -webkit-align-items: center;
        align-items: center;
        flex-wrap: wrap;
        div {
            width: 50%;
            height:30px;
            line-height:30px;
            overflow: hidden;
            white-space: nowrap;
            text-overflow: ellipsis;
            font-weight: 500;
            font-size: 16px;
            padding: 0 16px;
        }
        .time{
            flex-basis:100% !important;
        }
    }
    .more{
        align-items: center;
        display: -webkit-box;
        display: -webkit-flex;
        display: flex;
        -webkit-box-align: center;
        -webkit-align-items: center;
        align-items: center;
        justify-content: space-between;
        margin: 0 16px;
        padding-bottom: 10px;
        .moredevice{
            overflow: hidden;
            white-space: nowrap;
            text-overflow: ellipsis;
            font-weight: 500;
            font-size: 16px;
            max-width: 80%;
        }
        }
}
.bottom {
    display: flex;
    position: fixed;
    bottom: 0px;
    width:100%;
    .btnTrans {
        flex:1;
        background: var(--primary-color, #009688);
        margin: 5px;
        height: 40px;
        padding: 0px 30px;
        color: #ffffff;
    }
}

.line{
    margin:0px 24px;
    width:1px;
    height:130px;
    background:#EBEBEB;
}
.scrollContent{
    overflow-y: auto;
    overflow-x: hidden;
}
.content{
    display:flex;
    font-size:20px;
    .panel{
        position: relative;
        width: 100%;
        padding: 0 16px;
        text-align: left;
        .monthday{
            position: absolute;
            left:-40px;
            top:0px;
            opacity: 1;
            background: #fff;
            font-size:18px;
        }
        .date{
            position: absolute;
            left:-40px;
            top:8px;
            opacity: 1;
            background: #fff;
            font-size:18px;
        }
        .step{
            display: flex;
            flex-wrap: wrap;
            align-items: center;
            justify-content: start;
            font-size: 16px;
            color: rgba(102, 102, 102, 1);
        }
        .steprowone{
            flex-basis: 70%;
            font-weight: 500;
            font-size: 20px;
            color: var(--primary-color, #009688);
            line-height: 36px;
            height: 36px;
            text-align: left;
            font-style: normal;
            overflow-wrap: break-word;
            white-space: nowrap;
            margin-top: 1px;
        }
        .phone{
            background-color: #E0F2EE;
            border-radius: 50%;
            height: 24px;
            width: 24px;
            line-height: 24px;
            text-align: center;
        }
        .steprowtwo{
            flex-basis: 100%;
            margin-top: 5px;
        }
        .remark{
            flex-basis: 90%;
            padding: 5px 10px 10px 0px;
            background-color: rgba(245, 245, 245, 1);
            border-radius: 2px;
        }
    }
    }
</style>



// WEBPACK FOOTER //
// src/components/Mobile/Transfer/TransferInfo.vue